// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"309":"88050694","332":"2689d524","972":"ac679bae"}[chunkId] + ".chunk.js";
};